import React from 'react';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import ReactOnRails from 'react-on-rails';
import { BrowserRouter } from 'react-router-dom';
import AdminMarketplaceContainer from '../../containers/coachLed/AdminMarketplaceContainer.jsx';

const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': ReactOnRails.authenticityToken() },
  }),
  cache: new InMemoryCache(),
});

export default class CoachLedAdminMarketplacePage extends React.Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <BrowserRouter>
          <AdminMarketplaceContainer {...this.props} />
        </BrowserRouter>
      </ApolloProvider>
    );
  }
}


